import { connect } from 'react-redux';
import { setSelectedTerm } from '../../../../actions/orders';
import { setUrlParam } from '../../../../actions/settings';
import TermSelect from './TermSelect';

export default connect(
  ({
    frames, product, order, settings,
  }) => ({
    capacity: product.data.capacity.quantity,
    capacityType: product.data.capacity.type,
    flattenTimeSlots: frames.flattenTimeSlots,
    loading: frames.loading,
    mindate: product.data.mindate || 0,
    selectedLocation: order.selectedLocation,
    selectedResource: order.selectedResource,
    settings,
    terms: product.data.terms || [],
    termSelected: order.termSelected,
    variants: order.variants,
    variantSelected: order.variantSelected,
    quantity: order.quantity || 1,
  }),
  (dispatch) => ({
    setSelectedTerm: (a) => dispatch(setSelectedTerm(a)),
    setUrlParam: (k, v) => dispatch(setUrlParam(k, v)),
  }),
)(TermSelect);
